import { Container } from '../../ui'
import cn from 'classnames'

import c from './assets/sass/howWorks.module.scss'

const HowWorks = () => {
    return (
        <section className={c.component}>
            <Container>
                <div className={c.title}>Как мы работаем?</div>
                <ul className={c.list}>
                    <li className={cn(c.item, c.booking)}>
                        <div className={c.number}>1</div>
                        <div className={c.itemTitle}>Запись</div>
                        <div className={c.subtitle}>
                            По телефону или на сайте
                        </div>
                    </li>
                    <li className={cn(c.item, c.contact)}>
                        <div className={c.number}>2</div>
                        <div className={c.itemTitle}>Связь с вами</div>
                        <div className={c.subtitle}>
                            Уточнение деталей визита
                        </div>
                    </li>
                    <li className={cn(c.item, c.procedure)}>
                        <div className={c.number}>3</div>
                        <div className={c.itemTitle}>Процедура</div>
                        <div className={c.subtitle}>
                            Наш специалист ждет Вас!
                        </div>
                    </li>
                </ul>
            </Container>
        </section>
    )
}

export default HowWorks
